export default function (phone) {
  let res = phone.replace(/\D/g, "");
  if (res.length >= 4 && res.length <= 6) {
    res = res.replace(/(\d{3})(\d{0,3})/, "$1-$2");
  } else if (res.length === 6 || res.length === 7) {
    res = res.replace(/(\d{3})(\d{3,4})/, "$1-$2");
  } else if (res.length > 7 && res.length <= 10) {
    res = res.replace(/(\d{3})(\d{3})(\d{0,4})/, "$1-$2-$3");
  } else {
    res = res.replace(/(\d{3})(\d{4})(\d{0,4})/, "$1-$2-$3");
  }
  return res;
}
